/* eslint-disable */
import axios from '../index'

const getAll = () => {
  return axios.get('news')
}
const getAllTelim = () => {
  return axios.get('telim')
}
const getWithId = (id) => {
  return axios.get(`news/${id}`)
}
const getAllEvents = () => {
  return axios.get('events')
}
const getHome = () => {
  return axios.get('home/news')
}
const getHomeTelim = () => {
  return axios.get('home/telim')
}
const getHomeEvents = () => {
  return axios.get('home/events')
}

const api = { getAll, getWithId, getHome, getAllTelim, getHomeTelim, getAllEvents, getHomeEvents }

export default api;